export default {
  name: 'App'
}



// WEBPACK FOOTER //
// ./src/components/App/App.js